import React from "react";
import {
  FaMapMarkedAlt,
  FaArrowRight,
  FaCar,
  FaGlobeAsia,
} from "react-icons/fa";

const locations = [
  {
    title: "Mumbai Outstation Cabs",
    image: "/images/network/Mumbai-Outstations.png",
    icon: <FaCar />,
    desc: "Safe and comfortable outstation taxi services from Mumbai across Maharashtra & India.",
    link: "/Mumbai-Outstation-Cabs",
  },

  {
    title: "Mumbai ↔ Pune",
    image: "/images/network/Mumbai--Pune---Mumbai.png",
    icon: <FaMapMarkedAlt />,
    desc: "Daily one-way and round-trip cab service between Mumbai and Pune.",
    link: "/Mumbai-to-Pune-Cab",
  },

  {
    title: "Goa",
    image: "/images/network/Goa.png",
    icon: <FaMapMarkedAlt />,
    desc: "Comfortable Goa taxi service for holidays, family tours and business trips.",
    link: "/Mumbai-to-Goa-Cabs",
  },

  {
    title: "Kolhapur",
    image: "/images/network/kolhapur.png",
    icon: <FaMapMarkedAlt />,
    desc: "Reliable Kolhapur cab booking with experienced professional drivers.",
    link: "/Mumbai-to-Kolhapur-Cab",
  },

  {
    title: "Nashik",
    image: "/images/network/Nashik.png",
    icon: <FaMapMarkedAlt />,
    desc: "Taxi services for business travel, tourism and religious destinations.",
    link: "/Mumbai-to-Nashik-Cab",
  },

  {
    title: "Pune",
    image: "/images/network/Pune.png",
    icon: <FaMapMarkedAlt />,
    desc: "Airport, corporate and outstation taxi services from Pune.",
    link: "/Mumbai-to-Pune-Cab",
  },

  {
    title: "Aurangabad",
    image: "/images/network/Aurangabad.png",
    icon: <FaMapMarkedAlt />,
    desc: "Travel comfortably to Sambhaji Nagar, Ellora and Ajanta.",
    link: "/Mumbai-to-Aurangabad-Cab",
  },

  {
    title: "Pan India",
    image: "/images/network/Mumbai-to-Pan-India.png",
    icon: <FaGlobeAsia />,
    desc: "Book cabs from Mumbai to any destination across India.",
    link: "/Explore-India-Pan-India-Cab-Booking-Services",
  },
];

const Network = () => {
  return (

<>


     <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Our Network
        </h2>
      </div>
    </section>

    <section className="network-section">

      <div className="container">

        {/* <div className="network-heading text-center">

          <span>OUR SERVICE NETWORK</span>

          <h2>
            Connecting Mumbai To
            <br />
            Every Destination
          </h2>

          <p>
            Shreesha Tours & Travels provides reliable local, airport,
            outstation and Pan India taxi services with professional
            chauffeurs and a modern fleet.
          </p>

        </div> */}

        <div className="row">

          {locations.map((item, index) => (

            <div className="col-lg-4 col-md-6 mb-4" key={index}>

              <div className="network-card">

                <img
                  src={item.image}
                  alt={item.title}
                />

                <div className="network-overlay">

                  <div className="network-icon">

                    {item.icon}

                  </div>

                  <h4>{item.title}</h4>

                  <p>{item.desc}</p>

                  {/* <a href={item.link}>
                    Explore Route
                    <FaArrowRight />
                  </a> */}

                </div>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>

</>
  );
};

export default Network;